import { Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MmtCommonService } from '../../services/mmt-common.service';
import { takeWhile } from 'rxjs/operators';
@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent implements OnInit, OnDestroy {
  loading: boolean;
  message: string;
  progressValue: number;
  progressValueStyle: string;
  private _subscribed: boolean = true;

  constructor(private pageLoaderService: MmtCommonService) { }

  ngOnInit(): void {
    this.subscribe();
  }
  private subscribe() {
    this.pageLoaderService._loaderState
      .pipe(takeWhile(() => this._subscribed))
      .subscribe(loading => {
        this.loading = loading;
      });
    this.pageLoaderService.loaderMessage
      .pipe(takeWhile(() => this._subscribed))
      .subscribe(message => {
        if (!!message) {
          this.message = message;
        }
      });
    this.pageLoaderService.loaderprogressValue
      .pipe(takeWhile(() => this._subscribed))
      .subscribe(progressValue => {
        if (!!progressValue) {
          this.progressValue = progressValue;
          this.progressValueStyle = `${progressValue}%`;
        }
      });
  }
  ngOnDestroy() {
    this._subscribed = false;
  }
}